import { z } from 'zod';

export const getEstatesFiltersSchema = () => {
  return z.object({
    rooms: z
      .object({
        min: z.number().optional(),
        max: z.number().optional(),
      })
      .optional(),
    rentalPrices: z
      .object({
        min: z.number().optional(),
        max: z.number().optional(),
      })
      .optional(),
    buyingPrices: z
      .object({
        min: z.number().optional(),
        max: z.number().optional(),
      })
      .optional(),
    heatingType: z.string().optional(),
    flooring: z.string().optional(),
    glazing: z.string().optional(),
    loggia: z.boolean().optional(),
    balcony: z.boolean().optional(),
    garden: z.boolean().optional(),
    parkingSpace: z.boolean().optional(),
    basement: z.boolean().optional(),
    elevator: z.boolean().optional(),
    minLivingArea: z.number().optional(),
    maxLivingArea: z.number().optional(),
    usageType: z.string().optional(),
    marketType: z.string().optional(),
    searchString: z.string().optional(),
    propertyType: z.string().optional(),
    propertyLevel: z.string().optional(),
    creatorId: z.string().optional(),
    projectId: z.string().optional(),
    buildingId: z.string().optional(),
    createdAt: z
      .object({
        min: z.string().optional(),
        max: z.string().optional(),
      })
      .optional(),
    updatedAt: z
      .object({
        min: z.string().optional(),
        max: z.string().optional(),
      })
      .optional(),
  });
};

export type EstatesFiltersSchemaType = z.infer<ReturnType<typeof getEstatesFiltersSchema>>;

export const DEFAULT_ESTATE_FILTERS_VALUES: EstatesFiltersSchemaType = {
  rooms: {
    min: undefined,
    max: undefined,
  },
  rentalPrices: {
    min: undefined,
    max: undefined,
  },
  buyingPrices: {
    min: undefined,
    max: undefined,
  },
  createdAt: {
    min: '',
    max: '',
  },
  updatedAt: {
    min: '',
    max: '',
  },
  heatingType: '',
  flooring: '',
  glazing: '',
  loggia: false,
  balcony: false,
  garden: false,
  parkingSpace: false,
  basement: false,
  elevator: false,
  minLivingArea: undefined,
  maxLivingArea: undefined,
  usageType: '',
  marketType: '',
  searchString: '',
  propertyType: '',
  propertyLevel: '',
  projectId: '',
  buildingId: undefined,
  creatorId: undefined,
};
